{
  "@context": "https://schema.org",
  "@type": "Game",
  "name": "CS Mines",
  "alternateName": [
    "csgo mines", "cs2 mines", "cs mines", "cs miner game", "cs go mines",
    "csgo miner game"
  ],
  "description": "A CS-inspired game where players reveal safe spots while avoiding mines.",
  "url": "https://6cs.fail/en/mines"
}
